import { getActiveFilter } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { useStateHooks } from '../../../state'
import { TableName } from '../../../tables'
import { firstItem } from '../../../utils/listUtils'
import { useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { Tax } from '../state/types'

export const useTaxLoaders = () => {
    const systemHooks = useSystemStateHooks()
    const { getList, find, findByParams } = useStateHooks()
    
    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const findAllTaxes = (active = false) => getList(TableName.TAXES, active) as Tax[]

        const findTax = (id?: string) => find(TableName.TAXES, id) as O<Tax>

        const findTaxByCode = (code: string) => firstItem(findByParams(TableName.TAXES, { code })) as O<Tax>

        const loadAllTaxes = async (active = false) => {
            const { loadMultiple } = loaders(companyId)
            const options = active ? getActiveFilter() : undefined
            const response = await loadMultiple(TableName.TAXES, options)
            return response.dataTypes as Tax[]
        }

        const loadTax = (
            id: string,
            dbRequest = false
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.TAXES, id, dbRequest) as Promise<O<Tax>>
        }

        return {
            findAllTaxes,
            findTax,
            findTaxByCode,
            loadAllTaxes,
            loadTax
        }
    }
}
